import React from 'react';
import { Outlet } from 'react-router';

import styled from 'styled-components';

import { ErrorBoundaryReset } from 'components/error/ErrorBoundary';

import Footer from '../../footer/Footer';

const BaseLayout = () => {
  return (
    <LayoutWrapper id="page-content-wrapper">
      <div className="inavi_content">
        <ErrorBoundaryReset>
          <Outlet />
        </ErrorBoundaryReset>
      </div>
      <Footer />
    </LayoutWrapper>
  );
};

export default BaseLayout;

export const LayoutWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: calc(100vh - 66px);
  overflow: visible;
  &.active {
    margin-left: 0;

    section {
      margin: 0 auto;
    }
  }

  .inavi_content {
    position: relative;
    /* flex-direction: column; */
    // max-width: 1280px;
    max-width: 1440px;
    width: 100%;

    @media screen and (max-width: 768px) {
      padding: 0 0 40px;
    }
  }
`;
